import { Link } from "react-router-dom";
import { ArrowLeft, Youtube } from "lucide-react";
import { LOGO_URL, CHANNEL_SUBSCRIBE_URL } from "../lib/api";
import { SkyDecor } from "./SkyDecor";
import { Footer } from "./Footer";
import { t } from "../i18n";

export const SubscribeButton = ({ className = "", testId = "subscribe-youtube-btn" }) => (
  <a href={CHANNEL_SUBSCRIBE_URL} target="_blank" rel="noopener noreferrer" data-testid={testId}
    className={`btn-3d ${className}`} style={{ "--c": "#F0303A" }}>
    <Youtube className="w-6 h-6" strokeWidth={2.5} />
    <span>{t("nav.subscribe")}</span>
  </a>
);

const Header = ({ back }) => (
  <header className="relative z-10 flex items-center justify-between gap-3 px-4 sm:px-8 pt-4">
    <div className="flex items-center gap-3">
      {back && (
        <Link to={back} data-testid="header-back-btn" aria-label={t("nav.back")}
          className="btn-3d !min-h-[56px] !w-14 !p-0 is-off">
          <ArrowLeft className="w-7 h-7" strokeWidth={3} />
        </Link>
      )}
      <Link to="/" data-testid="header-logo-link" aria-label={t("nav.home")}>
        <img src={LOGO_URL} alt="MIZUBINI" className="w-16 h-16 sm:w-20 sm:h-20 rounded-[22px] border-4 border-white shadow-lg object-cover" />
      </Link>
    </div>
    <a href={CHANNEL_SUBSCRIBE_URL} target="_blank" rel="noopener noreferrer" data-testid="header-subscribe-btn"
      aria-label={t("nav.subscribe")} className="btn-3d !min-h-[56px] !px-4 !text-base" style={{ "--c": "#F0303A" }}>
      <Youtube className="w-6 h-6" strokeWidth={2.5} />
      <span className="hidden sm:inline">{t("nav.subscribe")}</span>
    </a>
  </header>
);

export const Layout = ({ children, back }) => (
  <div className="sky-bg relative overflow-x-hidden">
    <SkyDecor />
    <Header back={back} />
    <main className="relative z-10 mx-auto max-w-5xl px-4 sm:px-8 pb-16 pt-6">{children}</main>
    <Footer />
  </div>
);
